const css = `.z0A_vG__emptyState{margin-top:128px}.z0A_vG__gradient{width:446px;height:25px;background:linear-gradient(var(--base-backgrounds-default)0%,transparent 100%);position:fixed;top:170px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"gradient":"z0A_vG__gradient","emptyState":"z0A_vG__emptyState"};
